export default function getDefaultSelectValues(items) {
  const defaultSelectValues = {}
  if (!items) return defaultSelectValues
  items.forEach((item) => {
    if (item.value && item.type === 'select') defaultSelectValues[item.name] = item.value.toString()
  })
  return defaultSelectValues
}
